import { createContext, useContext, type ReactNode } from 'react';
import type { DocumentAudience } from '@/blocks/domain/helpers/lineItemsColumnKeys';

const DocumentAudienceContext = createContext<DocumentAudience>('internal');

export interface DocumentAudienceProviderProps {
  audience?: DocumentAudience;
  children: ReactNode;
}

export function DocumentAudienceProvider({ audience = 'internal', children }: DocumentAudienceProviderProps) {
  return <DocumentAudienceContext.Provider value={audience}>{children}</DocumentAudienceContext.Provider>;
}

export function useDocumentAudience(): DocumentAudience {
  return useContext(DocumentAudienceContext);
}

export type { DocumentAudience };
